import { render, staticRenderFns } from "./forms-save-btn.vue?vue&type=template&id=51c12fbf&"
import script from "./forms-save-btn.vue?vue&type=script&lang=js&"
export * from "./forms-save-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports